import { useCallback, useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import platformMessagesService from '../services/platformMessagesService';

const REFRESH_MS = 5 * 60 * 1000;

export function usePlatformMessages() {
  const { userProfile, user } = useAuth();
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);

  const countryId = userProfile?.country_id ?? null;

  const refresh = useCallback(async () => {
    if (!user?.id) {
      setMessages([]);
      return;
    }
    setLoading(true);
    try {
      const list = await platformMessagesService.listActiveForViewer(countryId);
      setMessages(list);
    } catch (e) {
      console.error('[usePlatformMessages]', e);
      setMessages([]);
    } finally {
      setLoading(false);
    }
  }, [user?.id, countryId]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  useEffect(() => {
    if (!user?.id) return undefined;
    const id = setInterval(refresh, REFRESH_MS);
    return () => clearInterval(id);
  }, [user?.id, refresh]);

  return { messages, loading, refresh };
}
